import { CPContactPerson } from "../../../api/models/unified";
import { Title } from "../../../components";
import AccountListItem from "./AccountListItem";

interface AccountsListProps {
  title: string;
  description?: string;
  contactPeople: CPContactPerson[];
}

const AccountsList = ({
  contactPeople,
  title,
  description,
}: AccountsListProps) => {
  return (
    <>
      <Title title={title} size="big" className="text-primary" />
      {description && <p className="mt-2">{description}</p>}
      <div className="mt-2 mb-6">
        {contactPeople.map((account) => (
          <AccountListItem
            key={`${account.tenantCode}-${account.customerId}`}
            contactPerson={account}
          />
        ))}
      </div>
    </>
  );
};

export default AccountsList;
